import { useDispatch } from "react-redux";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiResponse } from "types/api";

import { TiVoDeviceOem } from "./types";

export const useCreateOem = (platformId?: string) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation<ApiResponse<TiVoDeviceOem>, Error, Partial<TiVoDeviceOem>>(
    {
      mutationFn: async (data) =>
        dispatch(
          apiThatThrows.createTiVoOem.action({
            params: { platformId },
            options: {
              body: JSON.stringify({
                data: {
                  type: "TiVoDeviceOem",
                  attributes: data,
                },
              }),
            },
          })
        ),
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: ["platforms"] });
      },
    }
  );
};
